// extracted by mini-css-extract-plugin
export default {"card":"card__g_xdw","tagButton":"tagButton__p7vBH","lesson":"lesson__vaUHJ","disabledLink":"disabledLink__nRHEy"};